// @ts-strict-ignore
import React, { FC } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import db from 'mobile_web/modules/db'
import { ManifestBadgeGroups } from 'mytours-read-api-typescript'
import { Language } from 'mytours-read-common'
import { getDirMode } from '../../platform'
import { IonGrid, IonRow } from '@ionic/react'
import BadgeComponent from './BadgeCard'

interface BadgeGroupBlockProps {
	group: ManifestBadgeGroups
	currentLanguage?: Language
}

const BadgeGroupBlock: FC<BadgeGroupBlockProps> = ({ group }) => {
	const badgeGroup = useLiveQuery(() => db.badgeGroups.get({ id: group?.id }), [group])
	const badges = useLiveQuery(() => db.badges.where({ group_id: group.id }).toArray()) || []
	const recentlyEarnedBadges = useLiveQuery(() => db.recentlyEarnedBadges.toArray())
	const allEarnedBadges = recentlyEarnedBadges ? recentlyEarnedBadges.map((badge) => badge.badge_id) : []
	const earnedBadges = badges.filter(badge => allEarnedBadges.includes(badge.id))

	return badges.length > 0 ? (
		<IonGrid dir={getDirMode()} className="block badge-group-block">
			<IonRow dir={getDirMode()} className="block-header">
				<h2 className="subheading">{badgeGroup?.title}</h2>
			</IonRow>
			<IonRow className="block-content">
				{badges
					?.filter(badge => badge.visible_on_badge_list || earnedBadges.find(earnedBadge => earnedBadge.id === badge.id))
					?.sort((a, b) => a.position - b.position)
					?.map(badge => <BadgeComponent key={badge.id} id={badge.id} />)}
			</IonRow>
		</IonGrid>
	) : null
}

export default BadgeGroupBlock
